import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Asset } from '../models/asset';
import { assets } from '../palette/palette';


@Injectable()
export class PaletteService {

    constructor() { }

    getAssets(url: string, keyJWT: string): Observable<Asset[]> {
        return of(assets);
    }

    getWizardAssets(): Observable<Asset[]> {
        return of(assets);
    }

    getLibelle(type: string): string {
        let label: string;
        switch (true) {
            case type.includes('COMBO_BOX'):
                label = 'Label de liste';
                break;
            case type.includes('RADIO_LIST_HORIZONTAL'):
                label = 'Label de liste de choix horizontale';
                break;
            case type.includes('RADIO_LIST_VERTICAL'):
                label = 'Label de liste de choix verticale';
                break;
            case type.includes('RADIO_BUTTON'):
                label = 'Label de choix';
                break;
            case type.includes('HEADER'):
                label = 'Label de titre';
                break;
            case type.includes('MESSAGE'):
                label = 'Label de message';
                break;
            case type.includes('TEXT'):
                label = 'Label de texte';
                break;
            case type.includes('INTEGER'):
                label = 'Label d\'entier';
                break;
            case type.includes('CHECK_BOX'):
                label = 'Label de choix';
                break;
            case type.includes('DATE'):
                label = 'Label de date';
                break;
            case type.includes('CONTAINER'):
                label = 'Label de groupe';
                break;
            default:
                label = 'Label';
        }
        return label;
    }

}
